import PropTypes from "prop-types";

const propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium", "large"])
};

export default propTypes;
